export default {"src":"https://s91588.cdn.ngenix.net/affiliates-frontend/_next/static/media/mfo.dd504398.svg","height":310,"width":370};